import { Check } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import DotDivider from 'components/shared/DotDivider';
import zeplinColor from 'theme/Color';
import { validationRules } from '../utils';
import { muiStyles } from './muiStyles';

const ValidationChecklist = ({ password }: { password: string }) => {
  const rules = validationRules(password);

  return (
    <Box sx={muiStyles.root}>
      {rules.map(({ rule, text }) => (
        <Box sx={muiStyles.content}>
          {rule ? (
            <Check fontSize='small' color='success' />
          ) : (
            <Box sx={muiStyles.dotContainer}>
              <DotDivider color={zeplinColor.Neutral9} />
            </Box>
          )}
          <Typography variant='responsiveBody3'>{text}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ValidationChecklist;
